import { render } from "./ConsentsUser.vue?vue&type=template&id=4f772647"
import script from "./ConsentsUser.vue?vue&type=script&lang=js"
export * from "./ConsentsUser.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__